import React, { Component } from "react";
import { Toast, Modal, Button } from "antd-mobile";
import { signTruckBrokerContractForTms } from "../../../services/author";
import styles from "./signActionSheet.less";
import { RightOutline } from 'antd-mobile-icons';
import { notify } from '../utils'
import { getPathParams } from "../../../utils/utils";
export default class SignActionSheet extends Component {
  state = {
    driverPartyId: "",
    sourceEnv: null,
    paramObj: {},
    contractDetail: [],
    active: '',
    backUrl: '' //T3.6.2外部注册签署协议后回跳地址
  };

  componentDidMount() {
    if (window.__wxjs_environment === 'miniprogram') {
      this.setState({
        sourceEnv: 'miniprogram',
      });
    }
    const obj = this.props
    this.props.rowKey && sessionStorage.setItem('paramObj', JSON.stringify(obj))
    this.setState({
      ...obj,
      paramObj: obj
    })
  }

  // 查看合同详情
  handleClick = item => {
    const { contractTemplateCode } = item;
    this.setState({
      active: contractTemplateCode
    })
    let lytHost = 'https://lyttest.tf56.com';
    if (!window.location.host.match("test") && !window.location.host.match("localhost")) {
      lytHost = "https://lyt.tf56.com";
    }
    sessionStorage.setItem('actionVisible', true)
    // 兼容小程序端部分机型无法打开word 及 PDF文档
    if (this.state.sourceEnv === 'miniprogram') {
      // 陆运通代收合同
      if (contractTemplateCode === 'TNC8F06376818B87CF') {
        window.open(`${lytHost}/lytMobile/wxCollectionContact.html`, '_self');
        return;
      }
      // 寿光分公司合同详情
      if (item.truckBrokerCompanyCode === 568301945 || item.truckBrokerCompanyCode === 1000000033) {
        window.open(`${lytHost}/lytMobile/wxContactDetail_shouguang.html`, '_self');
        return;
      }
      // 青岛分公司合同详情
      if (item.truckBrokerCompanyCode === 568141757 || item.truckBrokerCompanyCode === 12614022) {
        window.open(`${lytHost}/lytMobile/wxContactDetail.html`, '_self');
        return;
      }
      // 泉州公司合同详情
      if (item.truckBrokerCompanyCode === 568344581 || item.truckBrokerCompanyCode === 1000154510) {
        window.open(`${lytHost}/lytMobile/wxContactDetail_quanzhou.html`, '_self');
        return;
      }
    } else {
      this.props.history.push(
        `/agreementDetail?contractTemplateCode=${contractTemplateCode}`
      );
    }
  };

  // 不同意
  handleNo = () => {
    sessionStorage.removeItem('actionVisible')
    // this.props.history.push("/result?id=0");
    Toast.fail('签订失败')
    notify(false, this.state.sourceEnv, this.state.backUrl);
  };

  // 同意
  handleOk = () => {
    sessionStorage.removeItem('actionVisible')
    let { driverPartyId, paramObj, contractDetail, backUrl, sourceEnv } = this.state;
    const codes = [];
    contractDetail.forEach(i => {
      const { contractList } = i;
      contractList.forEach(j => {
        codes.push(j.contractTemplateCode);
      })
    });
    if (!paramObj.rowKey && sessionStorage.getItem('paramObj')) {
      paramObj = JSON.parse(sessionStorage.getItem('paramObj'))
    }
    sessionStorage.setItem('templetUniqueCodes', JSON.stringify(codes))
    let param = {
      platformCode: paramObj.platformCode,
      templetUniqueCodes: codes,
      partyId: driverPartyId,
      truckBrokerCompanyCode: paramObj.truckBrokerCompanyCode,
      key: paramObj.rowKey,
    };
    if (Number(paramObj.platformCode) === 100) {//平台模式
      param = {
        ...paramObj,
        ...param
      }
      console.log(paramObj, 'ok---------------------', param)
    }

    const obj = getPathParams(this.props.location.search);
    const identifyingCode = param.identifyingCode || sessionStorage.getItem('identifyingCode')
    const templetUniqueCodes = param.templetUniqueCodes || (sessionStorage.getItem('templetUniqueCodes') && JSON.parse(sessionStorage.getItem('templetUniqueCodes')))
    if (!param.userName) {
      param = {
        ...param,
        idCard: param.driverIdCard || obj.id,
        mobileNumber: param.outUserMobile || obj.mobile,
        userName: param.userName || obj.name,
        identifyingCode,
        ownerPartyId: param.ownerPartyId || obj.partyId,
        templetUniqueCodes,
      }
    }
    sessionStorage.removeItem('identifyingCode')
    sessionStorage.removeItem('templetUniqueCodes')
    signTruckBrokerContractForTms(param).then(data => {
      if (data.code === 0) {
        // this.props.history.push("/result?id=1");
        Toast.success('签订成功')
        //区分环境跳转（小程序、Android、IOS）
        notify(true, sourceEnv, backUrl);
      } else if (data.code === -10304) {
        // 部分协议签订失败
        Modal.alert(
          '签订失败，请刷新',
          data.msg,
          [
            { text: '取消', style: 'default' },
            {
              text: '刷新', onPress: () => {
                this.componentDidMount();
              }
            }
          ])
        notify(false, sourceEnv, backUrl);
      } else {
        Toast.fail(data.msg);
        notify(false, sourceEnv, backUrl);
      }
    });
  };

  render() {
    const { contractDetail, active } = this.state;
    return (
      <div style={{ paddingBottom: '100px' }}>
        {
          contractDetail && contractDetail.length && contractDetail.map(item => (
            <div>
              <div className="contentCom">{item.truckBrokerCompanyName}</div>
              {
                item.contractList && item.contractList.length && item.contractList.map((v) => (
                  <div className={`contentItem ${active === v.contractTemplateCode ? 'contentItem-active' : ''}`} onClick={() => this.handleClick(v)}>
                    <div className="contentItemText">《{v.contractTemplateName}》</div>
                    <div className="contentItemarrow"><RightOutline /></div>
                  </div>
                ))
              }
            </div>
          ))
        }
        <div className={styles.bottomView}>
          <Button onClick={this.handleNo} className={styles.btnBlack} style={{ lineHeight: 'auto' }}>不同意</Button>
          <Button type="primary" onClick={this.handleOk} className={styles.btn}>同意</Button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/author/contract/signActionSheet.js